var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_c('v-card-text',{staticClass:"text-center text-h2"},[_vm._v(" "+_vm._s(_vm.$t("message.success"))+" ")]),_c('v-card-text',{staticClass:"text-center"},[_c('v-icon',{attrs:{"size":"150","color":"success"}},[_vm._v("mdi-check-circle-outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }